import makeStyles from '@mui/styles/makeStyles';

export const useFullScreenStyles = makeStyles(() => ({
  fullScreenIcon: {
    color: 'white',
    // using classes={{ disabled: ... }} doesn't work because of a weird
    // specificity issue with the icon button classes
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.5)',
    },
  },
}));
